<template>
    <div>
        <div v-for="entry in fileList" style="background:white;display: flex;flex-flow: row;width: 100%;margin-bottom: 4px;border-bottom: 2px solid gray;">
            <div style="width: 150px;flex-shrink: 0;">
                <div style="width:100%;overflow: hidden;">
                    <img :src="entry.thumbPath" style="width: 100%; height: 100%; object-fit: cover;" />
                    <span>{{ entry.fileMsg }}</span>
                    <!-- <div>{{ lang.common.seq }}:<input type="text" v-model="entry.seq" class="form-control" /></div> -->
                </div>
            </div>
            <div style="flex: 1;padding: 4px;">
                <div>
                    <!-- <div>{{ lang.common.content }}:</div> -->
                    <textarea class="form-control" v-model="entry.textContent" :place-holder="lang.common.content" />
                </div>
                <div style="text-align: right;">
                    <span v-on:click="$emit('removeclicked', entry)" class="btn btn-default">{{lang.common.delete}}</span> | 
                    <button class="btn btn-primary" v-on:click="$emit('updateclicked', entry)">{{ lang.common.update }}</button>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    props: {
        files: Array
    },
    computed: {
        lang: function () {
            return this.$store.getters.lang;
        },
        fileList: function () {
            return this.files;
        }
    },
    methods: {
    }
}
</script>